export default __webpack_public_path__ + "static/media/sales.4fdfc2fd.svg";